import { MapView } from "@aws-amplify/ui-react";
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Marker } from "react-map-gl";

const MapComponent = observer(({ coordinates, initialViewState }) => {
	const [viewState, setViewState] = useState({
		latitude: 51.16676,
		longitude: 7.08844,
		zoom: 10,
	});

	useEffect(() => {
		if (initialViewState) setViewState(initialViewState);
	}, [initialViewState]);

	return (
		<MapView
			style={{ width: "auto", height: "400px" }}
			{...viewState}
			onMove={(evt) => setViewState(evt.viewState)}
		>
			{coordinates &&
				coordinates.map((coordinate) => (
					<Marker
						key={`marker-${coordinate.latitude}-${coordinate.longitude}`}
						latitude={coordinate.latitude}
						longitude={coordinate.longitude}
					/>
				))}
		</MapView>
	);
});

export default MapComponent;
